<div class="feedback-list-container">
    <div class="reservations-header">
        <div class="header-left">
            <img src="assets/images/icons/dashboard/shield_check_red.png" alt="shield_check_red Icon" class="file-icon">
            <span class="header-title">
                <span class="title-text">Réservations @if(feedbackData){ / <span class="username">{{feedbackData.reservationTitle}}</span>} / Évaluation du service</span>
            </span>
        </div>

        <div class="header-right">
            <button *ngIf="feedbackData && canEditFeedback(feedbackData)" class="back-btn" (click)="editFeedback(feedbackData)">
                <img src="./assets/images/icons/edit.png" alt="Modifier">
                <span>Modifier</span>
            </button>
            <button class="back-btn" (click)="viewReservation(feedbackData.reservationId)">
                <img src="assets/images/icons/back-arrow.png" alt="back" class="add-icon">
                <span>Retour</span>
            </button>
        </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
        <div class="spinner"></div>
        <p>Chargement de vos évaluations...</p>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage && !isLoading" class="alert-card-error">
        <div class="alert-title">Erreur</div>
        <div class="alert-text">{{ errorMessage }}</div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && !errorMessage && !feedbackData" class="empty-state">
        <div class="empty-icon">
            <img src="./assets/images/icons/star_empty.png" alt="Aucune évaluation">
        </div>
        <h3 class="empty-title">Aucune évaluation</h3>
        <p class="empty-text">
            Vous n'avez pas encore évalué de services.<br> Les évaluations seront disponibles après la complétion de vos réservations.
        </p>
    </div>

    <div *ngIf="!isLoading && !errorMessage && feedbackData" class="feedback-list">
        <div class="feedback-card">
            <!-- Card Header -->
            <div class="card-header">
                <div class="header-left">
                    <div class="reservation-info">
                        <h3 class="reservation-title">
                            {{ feedbackData.reservationTitle }}
                        </h3>
                        <div class="reservation-meta">
                            <span class="meta-item">
                                <img src="./assets/images/icons/calendar.png" alt="Date" class="meta-icon">
                                Soumis le {{ (feedbackData.submittedAt || feedbackData.createdAt)  }}
                            </span>
                        </div>
                    </div>
                </div>

                <div class="header-right">
                    <div class="rating-summary">
                        <div class="average-rating">
                            <span class="rating-value">{{ getAverageRating(feedbackData) | number:'1.1-1' }}</span>
                            <div class="rating-stars">
                                <div class="stars">
                                    <span *ngFor="let star of [1,2,3,4,5]" class="star" [class.active]="star <= getNote(feedbackData)">
                                        ★
                                    </span>
                                </div>
                                <span class="rating-text">Note moyenne</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="ratings-breakdown">
                <div class="breakdown-title">
                    <span>Détail des notes</span>
                </div>
                <div class="breakdown-grid">
                    <div class="breakdown-item">
                        <span class="breakdown-label">Service global</span>
                        <div class="breakdown-rating">
                            <div class="stars-small">
                                <span *ngFor="let star of [1,2,3,4,5]" class="star-small" [class.active]="star <= feedbackData.overallRating">
                                ★
                                </span>
                            </div>
                            <span class="rating-number">{{ feedbackData.overallRating }}/5</span>
                        </div>
                    </div>

                    <div class="breakdown-item">
                        <span class="breakdown-label">Qualité du service</span>
                        <div class="breakdown-rating">
                            <div class="stars-small">
                                <span *ngFor="let star of [1,2,3,4,5]" class="star-small" [class.active]="star <= feedbackData.serviceQualityRating">
                                ★
                                </span>
                            </div>
                            <span class="rating-number">{{ feedbackData.serviceQualityRating }}/5</span>
                        </div>
                    </div>

                    <div class="breakdown-item">
                        <span class="breakdown-label">Ponctualité</span>
                        <div class="breakdown-rating">
                            <div class="stars-small">
                                <span *ngFor="let star of [1,2,3,4,5]" class="star-small" [class.active]="star <= feedbackData.punctualityRating">
                                ★
                                </span>
                            </div>
                            <span class="rating-number">{{ feedbackData.punctualityRating }}/5</span>
                        </div>
                    </div>

                    <div class="breakdown-item">
                        <span class="breakdown-label">Communication</span>
                        <div class="breakdown-rating">
                            <div class="stars-small">
                                <span *ngFor="let star of [1,2,3,4,5]" class="star-small" [class.active]="star <= feedbackData.communicationRating">
                                ★
                                </span>
                            </div>
                            <span class="rating-number">{{ feedbackData.communicationRating }}/5</span>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="feedbackData.comment" class="comment-section">
                <div class="comment-title">
                    <span>Votre commentaire</span>
                </div>
                <div class="comment-text">
                    <p>{{ feedbackData.comment }}</p>
                </div>
            </div>

            <!-- Agent Feedbacks -->
            <div *ngIf="feedbackData.agentFeedbacks && feedbackData.agentFeedbacks.length > 0" class="agents-section">
                <div class="agents-title">
                    <span>Évaluation des agents ({{ feedbackData.agentFeedbacks.length }})</span>
                </div>
                <div class="agents-list">
                    <div *ngFor="let agent of feedbackData.agentFeedbacks" class="agent-item">
                        <div class="agent-info">
                            <div class="agent-image-col">
                                <img [src]="agent.profileImage || './assets/images/icons/user-default-icon.png'" [alt]="agent.agentName" class="agent-image" [class.full]="agent.profileImage">
                            </div>
                            <div class="agent-details">
                                <h4 class="agent-name">{{ agent.agentName }}</h4>
                                <span class="agent-email">{{ agent.agentEmail }}</span>
                            </div>
                        </div>
                        <div class="agent-ratings">
                            <div class="agent-rating-item">
                                <span class="rating-label">Professionalisme</span>
                                <div class="agent-stars">
                                    <span *ngFor="let star of [1,2,3,4,5]" class="agent-star" [class.active]="star <= agent.professionalismRating">
                                        ★
                                    </span>
                                    <span class="agent-rating-number">{{ agent.professionalismRating }}/5</span>
                                </div>
                            </div>
                            <div class="agent-rating-item">
                                <span class="rating-label">Attitude</span>
                                <div class="agent-stars">
                                    <span *ngFor="let star of [1,2,3,4,5]" class="agent-star" [class.active]="star <= agent.attitudeRating">
                                        ★
                                    </span>
                                    <span class="agent-rating-number">{{ agent.attitudeRating }}/5</span>
                                </div>
                            </div>
                            <div class="agent-rating-item">
                                <span class="rating-label">Efficacité</span>
                                <div class="agent-stars">
                                    <span *ngFor="let star of [1,2,3,4,5]" class="agent-star" [class.active]="star <= agent.efficiencyRating">
                                        ★
                                    </span>
                                    <span class="agent-rating-number">{{ agent.efficiencyRating }}/5</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="agent.comment" class="agent-comment">
                            <p class="comment-text-small">{{ agent.comment }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Card Footer -->
            <div class="card-footer">
                <div class="footer-left">
                    <div class="update-info">
                        <span class="update-count">
                        Mise à jour {{ feedbackData.updateCount }}/2
                        <span *ngIf="feedbackData.updateCount === 0" class="update-note">(Soumission initiale)</span>
                        <span *ngIf="feedbackData.updateCount === 1" class="update-note">(Première mise à jour)</span>
                        <span *ngIf="feedbackData.updateCount === 2" class="update-note">(Finalisée)</span>
                        </span>
                    </div>
                </div>

                <div class="footer-right">
                    <button *ngIf="canEditFeedback(feedbackData)" class="btn-edit" (click)="editFeedback(feedbackData)">
                        <img src="./assets/images/icons/edit.png" alt="Modifier">
                        <span>Modifier</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>